var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-textarea" },
    [
      _c(
        "validation-message",
        {
          attrs: {
            valid: _vm.valid,
            invalid: _vm.invalid,
            validationMessage: _vm.validationMessage
          }
        },
        [
          _c(
            "label",
            { staticClass: "c-textarea__label", attrs: { for: _vm.id } },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                staticClass: "c-textarea__field",
                attrs: {
                  id: _vm.id,
                  name: _vm.name,
                  disabled: _vm.disabled,
                  required: _vm.required,
                  readonly: _vm.readonly,
                  placeholder: _vm.placeholder
                },
                domProps: { value: _vm.value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.value = $event.target.value
                    },
                    _vm.updateValue
                  ],
                  change: _vm.changeValue
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "c-textarea__label-text" }, [
                _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.label) + "\n\t\t\t\t\t"),
                _vm.required
                  ? _c("span", { staticClass: "c-textarea__required" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c(
            "div",
            { staticClass: "c-tooltip" },
            [
              _c(
                "ToolTip",
                {
                  attrs: {
                    title: _vm.tooltipTitle,
                    isActive: _vm.isActiveTooltip
                  },
                  on: {
                    toggleTooltip: function(value) {
                      return _vm.$emit("toggleTooltip", value)
                    }
                  }
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.tooltipMessage) }
                  }),
                  _vm._v(" "),
                  _vm.tooltipImageUrl
                    ? _c("img", {
                        attrs: {
                          width: "84",
                          height: "117",
                          src: _vm.tooltipImageUrl,
                          alt: ""
                        }
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1496d94a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1496d94a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/forms/textarea/TextareaField.vue
// module id = 772
// module chunks = 0